module.exports = __webpack_public_path__ + "img/cam.f5855803.png";